import React, { ReactNode } from 'react';
import styled from 'styled-components';
import classNames from 'classnames';

interface IconButtonProps {
  active?: boolean;
  className?: string;
  size?: string;
  children?: ReactNode;
  disabled?: boolean;
  onClick?: () => void;
  'data-testid'?: string;
}

const Button = styled.button<IconButtonProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 3rem;
  height: 3rem;
  flex-shrink: 0;

  border-radius: 0.5rem;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: background-color 0.3s ease;

  svg {
    width: ${({ size }) => size || '1.5rem'};
    height: ${({ size }) => size || '1.5rem'};
    color: ${({ theme }) => theme?.palette?.text};
  }

  img {
    width: ${({ size }) => size || '1.5rem'};
    height: ${({ size }) => size || '1.5rem'};
    display: block;
  }

  &:hover {
    background-color: ${({ theme }) => theme?.palette?.iconButtonHoverBackground};

    svg {
      color: ${({ theme }) => theme?.palette?.accentText};
    }
  }

  &.active {
    background-color: ${({ theme }) => theme?.palette?.accent};

    svg {
      color: ${({ theme }) => theme?.palette?.accentText};
    }
  }
`;

export const IconButton: React.FC<IconButtonProps> = ({ active, disabled, onClick, children, className, size, 'data-testid': testId }) => (
  <Button className={classNames(className, { active: active })} onClick={onClick} disabled={disabled} size={size} data-testid={testId}>
    {children}
  </Button>
);
